if (!customElements.get("wls-product-upsell")) {
  class WLSUpsell extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector("wls-cart");
    }

    connectedCallback() {
      this.initializeElements();
      this.bindEvents();
    }

    initializeElements() {
      this.subscriptionRadio = this.querySelectorAll(
        'input[id="upsell-subscription"]'
      );
      this.priceElement = this.querySelector(".js-upsell-product-price");
      this.addToCartButtons = this.querySelectorAll(".js-upsell-add-to-cart"); // updated to all buttons
    }

    bindEvents() {
      this.subscriptionRadio.forEach((radio) => {
        radio.addEventListener("click", () =>
          this.handleSubscriptionChange(radio)
        );
      });

      this.addToCartButtons.forEach((button) => {
        button.addEventListener("click", () =>
          this.handleAddToCartClick(button)
        );
      });
    }

    handleSubscriptionChange(radio) {
      const subscriptionWrapper = radio.closest("[wls-subscription]");
      const price = subscriptionWrapper.dataset.price;
      const sellingPlanId = subscriptionWrapper.dataset.sellingPlanId;

      this.updatePrice(price);
      this.updateSellingPlan(sellingPlanId);
    }

    updatePrice(price) {
      this.priceElement.innerHTML = price;
    }

    updateSellingPlan(sellingPlanId) {
      this.addToCartButtons.forEach((button) => {
        button.dataset.sellingPlanId = sellingPlanId;
      });
    }

    handleAddToCartState(button, state) {
      const originalText = button.dataset.originalText || button.innerHTML;

      if (!button.dataset.originalText) {
        button.dataset.originalText = originalText;
      }

      if (state === "start") {
        button.innerHTML = `
      <svg class="wls-buybox__button-loader" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2391_2305)">
          <rect x="5.83984" y="18.5684" width="2.25" height="2.25" rx="1.125" transform="rotate(-45 5.83984 18.5684)" fill="white"/>
        </g>
        <g clip-path="url(#clip1_2391_2305)">
          <rect x="11.873" y="22.0015" width="2.25" height="2.25" rx="1.125" transform="rotate(-90 11.873 22.0015)" fill="white"/>
        </g>
        <g clip-path="url(#clip2_2391_2305)">
          <rect x="18.5703" y="20.1594" width="2.25" height="2.25" rx="1.125" transform="rotate(-135 18.5703 20.1594)" fill="white"/>
        </g>
        <g clip-path="url(#clip3_2391_2305)">
          <rect x="22.002" y="14.1265" width="2.25" height="2.25" rx="1.125" transform="rotate(-180 22.002 14.1265)" fill="white"/>
        </g>
        <g clip-path="url(#clip4_2391_2305)">
          <rect x="20.1602" y="7.43164" width="2.25" height="2.25" rx="1.125" transform="rotate(135 20.1602 7.43164)" fill="white"/>
        </g>
        <g clip-path="url(#clip5_2391_2305)">
          <rect x="14.123" y="4.00146" width="2.25" height="2.25" rx="1.125" transform="rotate(90 14.123 4.00146)" fill="#F1D077"/>
        </g>
        <g clip-path="url(#clip6_2391_2305)">
          <rect x="7.43359" y="5.84033" width="2.25" height="2.25" rx="1.125" transform="rotate(45 7.43359 5.84033)" fill="white"/>
        </g>
        <g clip-path="url(#clip7_2391_2305)">
          <rect x="4.00195" y="11.8765" width="2.25" height="2.25" rx="1.125" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_2391_2305"><rect width="18" height="18" fill="white" transform="translate(0.271484 13) rotate(-45)"/></clipPath>
          <clipPath id="clip1_2391_2305"><rect width="18" height="18" fill="white" transform="translate(3.99805 22.0015) rotate(-90)"/></clipPath>
          <clipPath id="clip2_2391_2305"><rect width="18" height="18" fill="white" transform="translate(13.002 25.7278) rotate(-135)"/></clipPath>
          <clipPath id="clip3_2391_2305"><rect width="18" height="18" fill="white" transform="translate(22.002 22.0015) rotate(-180)"/></clipPath>
          <clipPath id="clip4_2391_2305"><rect width="18" height="18" fill="white" transform="translate(25.7285 13) rotate(135)"/></clipPath>
          <clipPath id="clip5_2391_2305"><rect width="18" height="18" fill="white" transform="translate(21.998 4.00146) rotate(90)"/></clipPath>
          <clipPath id="clip6_2391_2305"><rect width="18" height="18" fill="white" transform="translate(13.002 0.271973) rotate(45)"/></clipPath>
          <clipPath id="clip7_2391_2305"><rect width="18" height="18" fill="white" transform="translate(4.00195 4.00146)"/></clipPath>
        </defs>
      </svg>
      <span>Adding</span>
    `;
        button.classList.add("adding-state");
      }

      if (state === "success") {
        button.innerHTML = `
      <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 3.7L3.7 6.39999L9.09999 1" stroke="#F1D077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Added</span>
    `;
        setTimeout(() => {
          button.innerHTML = button.dataset.originalText;
          button.classList.remove("adding-state");
        }, 2000);
      }
    }

    handleAddToCartClick(button) {
      const ids = button.dataset.productId.split(',');
      const quantity = 1;
      const sellingPlanId = button.dataset.sellingPlanId;

      this.handleAddToCartState(button, "start");

      fetch(window.location.origin + "/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            ...ids.map(id => ({
              id: id,
              quantity: quantity,
              selling_plan: sellingPlanId,
            })),
          ],
        }),
      }).then((response) => {
        if (response.ok) {
          this.handleAddToCartState(button, "success");
          this.refreshCart();
        }
      });
    }

    refreshCart() {
      fetch("/cart")
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newCart = doc.querySelector("cart-drawer");
          const newCartPage = doc.querySelector("wls-cart");
          const currentCart = document.querySelector("cart-drawer");
          const currentCartPage = document.querySelector("wls-cart");

          if (newCart) {
            currentCart.replaceWith(newCart);

            const header = document.querySelector("wls-header");
            if (header && header.handleCartIconClick) {
              header.elements.cartDrawer = newCart;
              header.handleCartIconClick();
            }

            if (!window.location.pathname.includes("/cart")) {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  header.openCartDrawer();
                });
              });
            }
          }

          if (newCartPage && currentCartPage) {
            currentCartPage.replaceWith(newCartPage);
          }
          const countBubble = document.querySelector(
            ".wls-header__cart-icon-bubble"
          );
          if (countBubble) {
            fetch("/cart.js")
              .then((res) => res.json())
              .then((cartData) => {
                countBubble.textContent = cartData.item_count || "";
              });
          }
        })
        .catch((err) => console.error("Error refreshing cart:", err));
    }
  }

  window.customElements.define("wls-product-upsell", WLSUpsell);
}
